import { createAction as ca } from 'redux-actions';

export const fetchActions = ['FETCH', 'RECEIVE', 'FAIL'];
export const saveActions = ['SAVE', 'RESULT', 'FAIL'];
export const binaryActions = ['SET', 'CLEAR'];
export const crudActions = [
  ...binaryActions,
  'RECEIVE',
  'FAIL',
  'CREATE',
  'READ',
  'UPDATE',
  'DELETE',
  'LIST',
  'CREATE_FAIL',
  'READ_FAIL',
  'UPDATE_FAIL',
  'DELETE_FAIL',
  'LIST_FAIL',
];

export function createTypes(base, actionsArray = fetchActions) {
  const res = {};
  actionsArray.forEach(type => {
    res[type] = `${base}_${type}`;
  });
  return res;
}

export function createAction(foo, bar) {
  const fun = ca(foo, bar);
  return args => {
    console.debug('[CALLING ACTION]', foo);
    return fun(args);
  };
}
